import {
  queryOptions,
  useMutation,
  useQueryClient
} from '@tanstack/react-query';

import API from '@api';

export const TASK_LIST_QUERY_KEY = 'taskList';

/**
 * Персональные задания: счётчики на главной (Opportunities), карусель на
 * «спасибо за покупку», задание в карточке товара — один кэш на всех.
 */
export const taskListQueryOptions = () =>
  queryOptions({
    queryKey: [TASK_LIST_QUERY_KEY],
    queryFn: () => API.getTaskList({}).then(res => res.getTasks),
    staleTime: 60 * 1000,
    gcTime: 5 * 60 * 1000
  });

/** Активация задания; на успех список заданий инвалидируется */
export const useAddTaskToProgressMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => API.addTaskToProgress({ id }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [TASK_LIST_QUERY_KEY] });
    }
  });
};
